// API client for the copyright-check backend
import { uploadApi } from './upload.api';

export type CopyrightStatus = 'idle' | 'checking' | 'clean' | 'flagged' | 'error';

export interface CopyrightCheckResult {
  status: 'clean' | 'flagged' | 'error';
}

const VALID_STATUSES = ['clean', 'flagged', 'error'] as const;

export const copyrightApi = {
  async check(file: File): Promise<CopyrightCheckResult> {
    try {
      const { url: videoUrl } = await uploadApi.uploadReel(file);
      const response = await fetch('/api/copyright-check', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ videoUrl }),
      });
      if (!response.ok) {
        return { status: 'error' };
      }
      const data = await response.json();
      if (!VALID_STATUSES.includes(data?.status)) {
        return { status: 'error' };
      }
      return data as CopyrightCheckResult;
    } catch {
      return { status: 'error' };
    }
  },
};
